var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:([_vm.fontFamily, _vm.fontSize, _vm.textoColor]),domProps:{"innerHTML":_vm._s(_vm.content.dsc_texto)}})
}
var staticRenderFns = []

export { render, staticRenderFns }